var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNautilusLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C12.2592 30 8.74218 28.5455 6.10076 25.8992C3.45448 23.253 2 19.7359 2 16C2 12.2641 3.45448 8.74218 6.10076 6.10076C8.74705 3.45448 12.2641 2 16 2C19.7359 2 23.2578 3.45448 25.8992 6.10076C28.5455 8.74705 30 12.2641 30 16C30 19.7359 28.5455 23.2578 25.8992 25.8992C23.253 28.5407 19.7359 30 16 30ZM16 2.7394C12.4587 2.7394 9.13134 4.11605 6.62613 6.62126C4.12092 9.12648 2.74427 12.4538 2.74427 15.9951C2.74427 19.5365 4.12092 22.8638 6.62613 25.369C9.13134 27.8742 12.4587 29.2509 16 29.2509C19.5413 29.2509 22.8687 27.8742 25.3739 25.369C27.8791 22.8638 29.2557 19.5365 29.2557 15.9951C29.2557 12.4538 27.8742 9.12648 25.369 6.62126C22.8687 4.11605 19.5365 2.7394 16 2.7394Z",
    fill: "#FFAE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 28.1817C12.8579 28.1817 10.4112 26.3676 9.23493 25.2907C7.58813 23.7798 6.43799 21.8925 6.43799 20.7006C6.43799 20.0209 6.82485 19.7334 7.73451 19.7334C8.41937 19.7334 9.34994 19.8955 10.4269 20.0889C11.9848 20.3607 13.9244 20.7058 16.0051 20.7058C18.0858 20.7058 20.0254 20.366 21.5833 20.0889C22.6602 19.9007 23.5908 19.7334 24.2757 19.7334C25.1853 19.7334 25.5722 20.0209 25.5722 20.7006C25.5722 21.8925 24.4221 23.7798 22.7753 25.2907C21.5885 26.3729 19.1418 28.1817 15.9999 28.1817Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2704 19.8219C24.6991 19.8219 24.9971 19.8847 25.1906 20.0206C25.384 20.1565 25.4781 20.3709 25.4781 20.7002C25.4781 21.6569 24.6103 23.4815 22.7073 25.2276C21.5415 26.2993 19.1157 28.0977 15.9999 28.0977C12.884 28.0977 10.4583 26.2993 9.29244 25.2276C7.38948 23.4815 6.52164 21.6569 6.52164 20.7002C6.52164 20.3709 6.61052 20.1565 6.80918 20.0206C7.00261 19.8847 7.3006 19.8219 7.72929 19.8219C8.4037 19.8219 9.33427 19.984 10.406 20.1722C11.9691 20.4493 13.9139 20.7891 15.9999 20.7891C18.0858 20.7891 20.0306 20.4493 21.5938 20.1722C22.6655 19.984 23.5908 19.8219 24.2704 19.8219ZM24.2704 19.6494C22.5818 19.6494 19.5078 20.6166 15.9999 20.6166C12.4919 20.6166 9.41791 19.6494 7.72929 19.6494C6.851 19.6494 6.34912 19.9108 6.34912 20.7055C6.34912 23.0267 10.6726 28.2755 15.9999 28.2755C21.3271 28.2755 25.6506 23.0214 25.6506 20.7002C25.6506 19.9108 25.1435 19.6494 24.2704 19.6494Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6013 19.7277C23.6013 21.5575 20.198 25.6928 15.9947 25.6928C11.7915 25.6928 8.39331 21.5523 8.39331 19.7277C8.39331 17.9032 11.7967 19.6598 15.9999 19.6598C20.2032 19.6598 23.6013 17.8979 23.6013 19.7277Z",
    fill: "#FFAE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 26.0269C12.4344 26.0269 9.61132 23.2614 8.58665 21.4002C8.49777 21.2382 8.55528 21.029 8.71734 20.9402C8.87941 20.8513 9.08853 20.9088 9.1774 21.0709C9.74725 22.106 10.7092 23.1411 11.8175 23.9201C12.7428 24.5683 14.2223 25.3473 15.9946 25.3473C16.1828 25.3473 16.3344 25.4989 16.3344 25.6871C16.3344 25.8753 16.1828 26.0269 15.9998 26.0269Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 21.6148C14.4263 21.6148 13.3441 21.5259 12.492 21.3325C11.5196 21.1077 10.819 20.7365 10.2858 20.1667C9.21405 19.0113 8.7749 16.962 8.7749 13.1037C8.7749 8.99982 12.0162 5.65918 15.9999 5.65918C19.9836 5.65918 23.2249 8.99982 23.2249 13.1037C23.2249 16.962 22.7857 19.0113 21.714 20.1667C20.5952 21.3743 18.6975 21.6148 15.9999 21.6148Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 5.73789C17.9081 5.73789 19.7013 6.50117 21.0501 7.8918C22.3989 9.28243 23.1465 11.1331 23.1465 13.0988C23.1465 16.9361 22.7178 18.9698 21.6566 20.1095C21.139 20.6688 20.4489 21.0348 19.4922 21.2544C18.6453 21.4478 17.5683 21.5367 15.9999 21.5367C14.4316 21.5367 13.3546 21.4478 12.5077 21.2544C11.551 21.0348 10.8609 20.6688 10.3433 20.1095C9.28729 18.9698 8.85337 16.9361 8.85337 13.0988C8.85337 11.1331 9.59574 9.28243 10.9498 7.8918C12.2933 6.5064 14.0918 5.73789 15.9999 5.73789ZM15.9999 5.58105C11.964 5.58105 8.69653 8.94784 8.69653 13.104C8.69653 20.627 10.3433 21.6935 15.9999 21.6935C21.6566 21.6935 23.3034 20.627 23.3034 13.104C23.3034 8.94784 20.0307 5.58105 15.9999 5.58105Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 20.627C20.0335 20.627 23.3034 17.2589 23.3034 13.104C23.3034 8.94921 20.0335 5.58105 15.9999 5.58105C11.9664 5.58105 8.69653 8.94921 8.69653 13.104C8.69653 17.2589 11.9664 20.627 15.9999 20.627Z",
    fill: "#FFAE00",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5771 7.11236C11.9117 6.86665 12.5286 6.62617 13.4383 7.10714L12.6959 6.40137L11.5771 7.11236Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4071 7.11236C20.0725 6.86665 19.4399 6.63139 18.5303 7.11759L19.2413 6.40137L20.4071 7.11236Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5078 5.35118C19.5078 4.4938 17.9342 3.80371 15.9946 3.80371C14.055 3.80371 12.4814 4.49903 12.4814 5.35118V6.04649C12.4814 6.90387 14.055 7.59396 15.9946 7.59396C17.9342 7.59396 19.5078 6.89864 19.5078 6.04649C19.5078 5.92625 19.5078 5.47142 19.5078 5.35118Z",
    fill: "#FFAE00",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0908 20.5855C10.7876 20.5855 10.5471 20.3397 10.5471 20.0418C10.5471 19.7438 10.7928 19.498 11.0908 19.498C11.3888 19.498 11.6345 19.7438 11.6345 20.0418C11.6345 20.3397 11.3888 20.5855 11.0908 20.5855ZM11.0908 19.7542C10.934 19.7542 10.8085 19.8797 10.8085 20.0365C10.8085 20.1934 10.934 20.3188 11.0908 20.3188C11.2477 20.3188 11.3731 20.1934 11.3731 20.0365C11.3731 19.8797 11.2477 19.7542 11.0908 19.7542Z",
    fill: "#FFEABD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8774 20.6792C20.5742 20.6792 20.3337 20.4335 20.3337 20.1355C20.3337 19.8375 20.5795 19.5918 20.8774 19.5918C21.1754 19.5918 21.4211 19.8375 21.4211 20.1355C21.4211 20.4335 21.1807 20.6792 20.8774 20.6792ZM20.8774 19.848C20.7206 19.848 20.5951 19.9734 20.5951 20.1303C20.5951 20.2871 20.7206 20.4126 20.8774 20.4126C21.0343 20.4126 21.1598 20.2871 21.1598 20.1303C21.1598 19.9734 21.0343 19.848 20.8774 19.848Z",
    fill: "#FFEABD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 6.08802C17.3828 6.08802 18.504 5.59415 18.504 4.98493C18.504 4.37571 17.3828 3.88184 15.9998 3.88184C14.6168 3.88184 13.4956 4.37571 13.4956 4.98493C13.4956 5.59415 14.6168 6.08802 15.9998 6.08802Z",
    fill: "url(#paint0_linear_2862_20014)",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 6.1769C14.1074 6.1769 12.6279 5.65411 12.6279 4.98494C12.6279 4.31576 14.1074 3.79297 15.9999 3.79297C17.8925 3.79297 19.372 4.31576 19.372 4.98494C19.372 5.65411 17.8872 6.1769 15.9999 6.1769ZM15.9999 3.97072C14.0917 3.97072 12.8109 4.49351 12.8109 4.98494C12.8109 5.47636 14.0917 5.99915 15.9999 5.99915C17.9081 5.99915 19.189 5.47636 19.189 4.98494C19.189 4.49351 17.9081 3.97072 15.9999 3.97072Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2583 5.50233C16.784 5.00045 15.0954 5.00045 13.7361 5.50233L13.6838 5.35595C15.0745 4.83838 16.8049 4.83838 18.3105 5.35595L18.2583 5.50233Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3262 4.682C16.8572 4.18012 15.0326 4.18012 13.6734 4.682L13.6211 4.53562C15.0065 4.02328 16.8781 4.02328 18.3785 4.53562L18.3262 4.682Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0275 6.07699C14.7818 5.41827 14.7818 4.57135 15.0275 3.86035L15.1739 3.91263C14.9439 4.59226 14.9439 5.40259 15.1739 6.02471L15.0275 6.07699Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9672 6.07211L16.8208 6.01983C17.0508 5.3402 17.0508 4.52987 16.8208 3.90775L16.9672 3.85547C17.2077 4.51419 17.2077 5.36111 16.9672 6.07211Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6518 7.98078C10.6675 7.95464 9.6062 9.57007 9.6062 9.57007L10.5472 10.5059C10.542 10.5059 9.84668 9.30345 10.6518 7.98078Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3271 7.98078C21.3114 7.95464 22.3727 9.57007 22.3727 9.57007L21.4316 10.5059C21.4369 10.5059 22.1322 9.30345 21.3271 7.98078Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0244 16.3082C9.72637 16.6689 9.47543 17.291 9.68978 17.6465L9.12516 16.7787C9.12516 16.7787 9.11471 15.9893 9.1513 15.9893C9.1879 15.9893 10.0244 16.3082 10.0244 16.3082Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9858 16.3709C22.2838 16.7316 22.5191 17.2858 22.3047 17.6465L22.8694 16.7787C22.8694 16.7787 22.8798 15.9893 22.8432 15.9893C22.8066 15.9893 21.9858 16.3709 21.9858 16.3709Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16172 9.54883C8.30434 9.54883 7.61426 11.1224 7.61426 13.062C7.61426 15.0016 8.30957 16.5752 9.16172 16.5752H9.4754C10.3328 16.5752 11.0229 15.0016 11.0229 13.062C11.0229 11.1224 10.3275 9.54883 9.4754 9.54883C9.34993 9.54883 9.28196 9.54883 9.16172 9.54883Z",
    fill: "#FFAE00",
    stroke: "black",
    strokeWidth: 0.165412,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62848 15.5611C9.2377 15.5611 9.73157 14.4399 9.73157 13.0569C9.73157 11.6739 9.2377 10.5527 8.62848 10.5527C8.01926 10.5527 7.52539 11.6739 7.52539 13.0569C7.52539 14.4399 8.01926 15.5611 8.62848 15.5611Z",
    fill: "url(#paint1_linear_2862_20014)",
    stroke: "black",
    strokeWidth: 0.165412,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85843 16.5957V16.418C9.36554 16.418 9.77855 14.9123 9.77855 13.0616C9.77855 12.1886 9.66876 11.326 9.48056 10.6934C9.29758 10.0817 9.05186 9.73146 8.80615 9.73146V9.55371C9.14597 9.55371 9.43873 9.93012 9.65308 10.6411C9.85174 11.2946 9.96153 12.152 9.96153 13.0616C9.9563 14.813 9.57989 16.5957 8.85843 16.5957Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99975 15.3728C8.48218 13.9822 8.48218 12.2517 8.99975 10.7461L9.14613 10.7984C8.64425 12.2726 8.64425 13.9613 9.14613 15.3205L8.99975 15.3728Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38802 15.5614C7.83909 14.0819 7.83909 12.1632 8.38802 10.5635L8.5344 10.6158C7.99592 12.1841 7.99592 14.061 8.5344 15.5091L8.38802 15.5614Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65451 14.2122C8.28855 14.2122 7.91214 14.1494 7.55664 14.0292L7.60892 13.8828C8.28855 14.1128 9.03614 14.1128 9.66349 13.8828L9.71577 14.0292C9.38641 14.1494 9.02569 14.2122 8.65451 14.2122Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66349 12.2359C8.98386 12.0059 8.23627 12.0059 7.60892 12.2359L7.55664 12.0896C8.21536 11.8438 9.00477 11.8438 9.71577 12.0896L9.66349 12.2359Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8118 9.54883C23.6692 9.54883 24.3593 11.1224 24.3593 13.062C24.3593 15.0016 23.664 16.5752 22.8118 16.5752H22.4982C21.6408 16.5752 20.9507 15.0016 20.9507 13.062C20.9507 11.1224 21.646 9.54883 22.4982 9.54883C22.6184 9.54883 22.6916 9.54883 22.8118 9.54883Z",
    fill: "#FFAE00",
    stroke: "black",
    strokeWidth: 0.165412,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3399 15.5611C23.9491 15.5611 24.443 14.4399 24.443 13.0569C24.443 11.6739 23.9491 10.5527 23.3399 10.5527C22.7307 10.5527 22.2368 11.6739 22.2368 13.0569C22.2368 14.4399 22.7307 15.5611 23.3399 15.5611Z",
    fill: "url(#paint2_linear_2862_20014)",
    stroke: "black",
    strokeWidth: 0.165412,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3399 16.4499C22.6707 16.4499 22.1479 14.96 22.1479 13.057C22.1479 11.154 22.6707 9.66406 23.3399 9.66406V9.84181C22.8485 9.84181 22.3257 11.1331 22.3257 13.0518C22.3257 14.9704 22.8485 16.2617 23.3399 16.2617V16.4499Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9686 15.3728L22.8223 15.3205C23.3241 13.9613 23.3241 12.2726 22.8223 10.7984L22.9686 10.7461C23.4862 12.2517 23.4862 13.9822 22.9686 15.3728Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5803 15.5614L23.434 15.5091C23.9724 14.061 23.9724 12.1841 23.434 10.6158L23.5803 10.5635C24.1293 12.1632 24.1293 14.0819 23.5803 15.5614Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3137 14.2122C22.9425 14.2122 22.5818 14.1494 22.2524 14.0292L22.3047 13.8828C22.9321 14.1128 23.6797 14.1128 24.3593 13.8828L24.4116 14.0292C24.0561 14.1494 23.6797 14.2122 23.3137 14.2122Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3047 12.2359L22.2524 12.0896C22.9687 11.8438 23.7529 11.8438 24.4116 12.0896L24.3593 12.2359C23.7319 12.0059 22.9844 12.0059 22.3047 12.2359Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4695 4.27415C13.6472 4.22187 13.7622 4.3578 13.7361 4.48327C14.0811 4.12777 14.6405 3.99707 14.6405 3.99707L13.4695 4.27415Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5302 4.27415C18.3524 4.22187 18.1956 4.38917 18.2845 4.53555C17.8924 4.23233 17.448 3.99707 17.448 3.99707L18.5302 4.27415Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.151618,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9738 17.5369C18.4078 17.5369 20.3809 15.5638 20.3809 13.1298C20.3809 10.6958 18.4078 8.72266 15.9738 8.72266C13.5398 8.72266 11.5667 10.6958 11.5667 13.1298C11.5667 15.5638 13.5398 17.5369 15.9738 17.5369Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.41553,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9737 16.8731C18.041 16.8731 19.7169 15.1972 19.7169 13.1299C19.7169 11.0626 18.041 9.38672 15.9737 9.38672C13.9064 9.38672 12.2305 11.0626 12.2305 13.1299C12.2305 15.1972 13.9064 16.8731 15.9737 16.8731Z",
    fill: "url(#paint3_linear_2862_20014)",
    stroke: "black",
    strokeWidth: 0.165412,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 16.513C17.0716 16.513 16.8102 16.4137 16.6116 16.215L12.8893 12.4927C12.492 12.0954 12.492 11.4471 12.8893 11.0446L13.8878 10.046C14.2852 9.64872 14.9334 9.64872 15.336 10.046L19.0583 13.7683C19.4556 14.1656 19.4556 14.8139 19.0583 15.2165L18.0597 16.215C17.8611 16.4137 17.5997 16.513 17.333 16.513ZM14.6093 10.0774C14.4211 10.0774 14.2486 10.1506 14.1179 10.2813L13.1193 11.2798C12.9886 11.4105 12.9154 11.583 12.9154 11.7713C12.9154 11.9595 12.9886 12.132 13.1193 12.2627L16.8416 15.985C17.1135 16.2568 17.5526 16.2568 17.8245 15.985L18.823 14.9864C19.0948 14.7146 19.0948 14.2754 18.823 14.0036L15.1007 10.2813C14.97 10.1454 14.7975 10.0774 14.6093 10.0774Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6093 16.513C14.3479 16.513 14.0865 16.4137 13.8878 16.215L12.8893 15.2165C12.492 14.8191 12.492 14.1709 12.8893 13.7683L16.6116 10.046C17.0089 9.64872 17.6572 9.64872 18.0597 10.046L19.0583 11.0446C19.4556 11.4419 19.4556 12.0902 19.0583 12.4927L15.336 16.215C15.1321 16.4137 14.8707 16.513 14.6093 16.513ZM14.1179 15.9797C14.2486 16.1104 14.4211 16.1836 14.6093 16.1836C14.7975 16.1836 14.97 16.1104 15.1007 15.9797L18.823 12.2575C19.0948 11.9856 19.0948 11.5465 18.823 11.2746L17.8245 10.2761C17.5526 10.0042 17.1135 10.0042 16.8416 10.2761L13.1193 13.9983C12.8475 14.2702 12.8475 14.7093 13.1193 14.9812L14.1179 15.9797Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2862_20014",
    x1: 18.4993,
    y1: 4.98634,
    x2: 13.4954,
    y2: 4.98634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2862_20014",
    x1: 8.62948,
    y1: 10.557,
    x2: 8.62948,
    y2: 15.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2862_20014",
    x1: 23.3402,
    y1: 10.557,
    x2: 23.3402,
    y2: 15.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2862_20014",
    x1: 12.2275,
    y1: 13.1295,
    x2: 19.7165,
    y2: 13.1295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC027"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNautilusLogoIcon);
export default __webpack_public_path__ + "static/media/nautilus-logo-icon.6072d19c.svg";
export { ForwardRef as ReactComponent };